var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Drawer as RMWCDrawer, DrawerHeader, DrawerTitle, DrawerContent, DrawerSubtitle, DrawerAppContent, } from '@rmwc/drawer';
import List from './list/List';
/**
 * Drawer component.
 *
 * @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/drawer.md
 *
 */
export default function Drawer(_a) {
    var id = _a.id, open = _a.open, _b = _a.setOpen, setOpen = _b === void 0 ? function () { } : _b, title = _a.title, subTitle = _a.subTitle, list = _a.list, appContent = _a.appContent, props = __rest(_a, ["id", "open", "setOpen", "title", "subTitle", "list", "appContent"]);
    var renderDrawer = function () {
        return (React.createElement(RMWCDrawer, __assign({ "aria-label": id, open: open, onClose: function () { return setOpen(false); }, className: "madonna-drawer" }, props),
            React.createElement(DrawerHeader, { className: "madonna-drawer-header" },
                React.createElement(DrawerTitle, { className: "madonna-drawer-title" }, title),
                subTitle && (React.createElement(DrawerSubtitle, { className: "madonna-drawer-subtitle" }, subTitle))),
            React.createElement(DrawerContent, { className: "madonna-drawer-content" },
                React.createElement(List, __assign({}, list)))));
    };
    return (props.dismissible ? (React.createElement("div", { className: "madonna-drawer-container" },
        renderDrawer(),
        React.createElement(DrawerAppContent, null, appContent))) : renderDrawer());
}
//# sourceMappingURL=Drawer.js.map